import { ContractorTitle, IconCalendarPerson } from '../../../../../../components/buttons/IconButtons';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import {
    DeleteContractFromWorkShift,
    DeleteUserFromWorkShift
} from '../../../../../../reduxToolkit/CompanyWorkShift/CompanyWorkShiftApi';
import { TABLES } from '../../../../../../Apis/Tables';
import { DeleteItemsApi } from '../../../../../../reduxToolkit/Commons/CommonsApi';
import { useDispatch } from 'react-redux';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const AccessRightsApp = (
    {
        workShiftsList, setWorkShiftsList,
        customizedList, setCustomizedList,
        contractorItemId,
        user
    }
) => {

    const MODEL_TABS_ACCESS_RIGHT = {
        WORK_SHIFT: {
            ID: 1,
            NAME: "WORK_SHIFT"
        },
        CUSTOM_SHIFT: {
            ID: 1,
            NAME: "CUSTOM_SHIFT"
        }
    }

    const TABS_ACCESS_RIGHT = [
        {
            id: MODEL_TABS_ACCESS_RIGHT.WORK_SHIFT.ID,
            key: MODEL_TABS_ACCESS_RIGHT.WORK_SHIFT.NAME,
            translation: "work_shift",
            icon: <IconCalendarPerson className="btn-icon-svg-20px icon-color-shades-400" />,
            textNoInfo: "search_for_work_shift"
        },
        {
            id: MODEL_TABS_ACCESS_RIGHT.CUSTOM_SHIFT.ID,
            key: MODEL_TABS_ACCESS_RIGHT.CUSTOM_SHIFT.NAME,
            translation: "custom_access",
            icon: <ContractorTitle className="btn-icon-svg-20px icon-color-shades-400" />,
            textNoInfo: "search_for_custom_shift"
        }
    ];

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [optionTabSelected, setOptionTabSelected] = useState(MODEL_TABS_ACCESS_RIGHT.WORK_SHIFT.NAME);

    const handleWorkShiftsDelete = (index) => {
        const item = workShiftsList[index];
        if (contractorItemId === undefined) {
            deleteUserFromWorkShift(user.id, item, index);
        } else {
            deleteContractFromWorkShift(user.id, item, index);
        }
    }

    const handleCustomizedDelete = (index) => {
        const tableName = !contractorItemId ? TABLES.USER_WORK_SCHEDULE : TABLES.CONTRACTOR_WORK_SCHEDULE;
        const item = customizedList[index];
        deleteItemsApi(tableName, item, index);
    }

    const deleteUserFromWorkShift = (userId, item, index) => {
        if (!item?.new) {
            const data = {
                userIds: [userId],
                workShiftIds: [item.id],
            };
            dispatch(DeleteUserFromWorkShift(data)).then(({ payload: { data: { success } } }) => {
                if (success === true) {
                    setWorkShiftsList((prevList) => prevList.filter((item, i) => i !== index));
                }
            });
        } else {
            setWorkShiftsList((prevList) => prevList.filter((item, i) => i !== index));
        }
    }

    const deleteContractFromWorkShift = (contractorId, item, index) => {
        if (!item?.new) {
            const data = {
                contractorIds: [contractorId],
                workShiftIds: [item.id],
            };
            dispatch(DeleteContractFromWorkShift(data)).then(({ payload: { data: { success } } }) => {
                if (success === true) {
                    setWorkShiftsList((prevList) => prevList.filter((item, i) => i !== index));
                }
            });
        } else {
            setWorkShiftsList((prevList) => prevList.filter((item, i) => i !== index));
        }
    }

    const deleteItemsApi = (tableName, item, index) => {
        if (!item?.new) {
            const body = [item.id];
            dispatch(DeleteItemsApi({ tableName, body })).then(({ payload: { data: { success } } }) => {
                if (success === true) {
                    setCustomizedList((prevList) => prevList.filter((item, i) => i !== index));
                }
            });
        } else {
            setCustomizedList((prevList) => prevList.filter((item, i) => i !== index));
        }
    }

    return {
        t,
        MODEL_TABS_ACCESS_RIGHT,
        TABS_ACCESS_RIGHT,
        optionTabSelected, setOptionTabSelected,
        handleWorkShiftsDelete,
        handleCustomizedDelete
    }

}

export default AccessRightsApp
